/** Present retained date meanings without repeating the generic primary date. */
export interface HistoryDateRow {
  key: string
  label: string
  value: string
  recordLink: boolean
}

const LABELS: Record<string, string> = {
  financial_date: 'Financial date',
  reference_date: 'Reference date',
  balance_as_of: 'Balance as of',
  checkpoint_date: 'Balance checkpoint',
  existence_date: 'Existence date',
  effective_date: 'Effective date',
  settlement_date: 'Settlement date',
  posting_date: 'Posting date',
  reporting_cutoff: 'Reporting cutoff',
  due_date: 'Due date',
  impact_from: 'Affects dates from',
}
const PRIMARY_MEANINGS = [
  'reference_date',
  'balance_as_of',
  'checkpoint_date',
  'effective_date',
  'existence_date',
  'reporting_cutoff',
  'settlement_date',
  'posting_date',
  'financial_date',
]

export function historyDateRows(
  financialDate: string | null,
  dates: Record<string, string>,
  subjectType: string
): HistoryDateRow[] {
  const rows = Object.entries(dates)
    .filter(
      ([key, value]) =>
        !(subjectType === 'position' && key === 'checkpoint_date' && value === dates.balance_as_of)
    )
    .map(([key, value]) => ({
      key,
      label: LABELS[key] ?? key.replace(/_/g, ' '),
      value,
      recordLink: false,
    }))
  if (!financialDate) return rows
  // Equal due/existence/settlement dates retain their distinct labels. Only
  // one existing primary-meaning row receives the Record link.
  const primary = PRIMARY_MEANINGS.flatMap((key) =>
    rows.filter((row) => row.key === key && row.value === financialDate)
  )[0]
  if (primary) {
    primary.recordLink = true
    return [primary, ...rows.filter((row) => row !== primary)]
  }
  return [
    { key: 'financial_date', label: LABELS.financial_date, value: financialDate, recordLink: true },
    ...rows,
  ]
}
